import React, { useEffect } from "react";
import Header from "../Templete/Header";
import Footer from "../Templete/Footer";

const AboutUs = () => {
  useEffect(() => {
    document.title = "About Us | FORMAX PAY";
  }, []);

  return (
    <>
      <Header />

      {/* Hero Section for About Page */}
      <section className="page-hero">
        <div className="container">
          <h1>About FORMAX PAY</h1>
          <p>
            A simple and reliable platform for mobile recharge, DTH recharge and
            bill payments.
          </p>
        </div>
      </section>

      <div className="container">
        {/* Main About Content */}
        <div className="about-content-full">
          <div className="about-grid">
            <div className="about-text-box">
              <h2>Who We Are</h2>
              <p>
                <strong>FORMAX PAY</strong> is a brand of{" "}
                <strong>FORMAX IT SOLUTIONS PRIVATE LIMITED</strong> (CIN:
                U72900WB2018PTC228240), a registered company in India. The
                platform is designed to provide a smooth and user-friendly
                experience for everyday recharge and payment requirements.
              </p>
              <p>
                We offer essential services such as{" "}
                <strong>
                  Mobile Recharge, DTH Recharge, Google Play Recharge, and
                  Utility Bill Payments
                </strong>
                . Our system is built to process transactions efficiently while
                maintaining accuracy and consistency.
              </p>
              <p>
                Our goal is to make these services easily accessible through a
                structured platform that focuses on simplicity, reliability, and
                convenience for all users.
              </p>
            </div>
            <div className="about-stats-card">
              <h3>
                <i className="fas fa-chart-line"></i> Why India trusts us
              </h3>
              <ul>
                <li>
                  <i className="fas fa-check-circle"></i> 5+ Years of Excellence
                </li>
                <li>
                  <i className="fas fa-check-circle"></i> 24/7 Customer Support
                </li>
                <li>
                  <i className="fas fa-check-circle"></i> Instant Recharge
                </li>
                <li>
                  <i className="fas fa-check-circle"></i> Zero Hidden Charges
                </li>
                <li>
                  <i className="fas fa-check-circle"></i> 5L+ Happy Users
                </li>
              </ul>
            </div>
          </div>

          {/* Mission & Vision */}
          <div className="mission-vision">
            <div className="mission">
              <i className="fas fa-bullseye"></i>
              <h3>Our Mission</h3>
              <p>
                To provide a simple, secure, and efficient platform for mobile
                recharge, DTH recharge, Google Play recharge, and utility bill
                payments, ensuring a smooth experience for every user.
              </p>
            </div>
            <div className="vision">
              <i className="fas fa-eye"></i>
              <h3>Our Vision</h3>
              <p>
                To build a trusted and accessible platform for recharge and bill
                payment services across India, focusing on reliability and ease
                of use.
              </p>
            </div>
          </div>

          {/* Key Milestones / Stats */}
          <div className="stats-section">
            <h2>Our Impact in Numbers</h2>
            <div className="stats-grid">
              <div className="stat-block">
                <h3>1L+</h3>
                <p>Active Users</p>
              </div>
              <div className="stat-block">
                <h3>500+</h3>
                <p>Operators & Brands</p>
              </div>
              <div className="stat-block">
                <h3>10L+</h3>
                <p>Transactions</p>
              </div>
              <div className="stat-block">
                <h3>24/7</h3>
                <p>Customer Support</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />

      {/* Additional CSS for about page (if not already in global) */}
      <style>{`
        .page-hero {
          background: linear-gradient(120deg, #eef2ff 0%, #f0f9ff 100%);
          padding: 50px 0 60px;
          text-align: center;
        }
        .page-hero h1 {
          font-size: 2.8rem;
          margin-bottom: 12px;
        }
        .page-hero p {
          color: #334155;
          max-width: 600px;
          margin: 0 auto;
        }
        .about-content-full {
          margin: 60px 0;
        }
        .about-grid {
          display: flex;
          flex-wrap: wrap;
          gap: 48px;
          margin-bottom: 60px;
        }
        .about-text-box {
          flex: 1.5;
          min-width: 260px;
        }
        .about-text-box h2 {
          font-size: 2rem;
          margin-bottom: 20px;
          color: #0f172a;
        }
        .about-text-box p {
          margin-bottom: 20px;
          line-height: 1.6;
          color: #334155;
        }
        .about-stats-card {
          flex: 1;
          background: #f1f5f9;
          padding: 32px;
          border-radius: 32px;
          box-shadow: var(--shadow-sm);
        }
        .about-stats-card h3 {
          font-size: 1.5rem;
          margin-bottom: 20px;
          color: #1e40af;
        }
        .about-stats-card ul {
          list-style: none;
        }
        .about-stats-card li {
          margin-bottom: 14px;
          display: flex;
          align-items: center;
          gap: 12px;
          font-weight: 500;
        }
        .about-stats-card li i {
          color: #1e40af;
          font-size: 1.2rem;
        }
        .mission-vision {
          display: flex;
          flex-wrap: wrap;
          gap: 40px;
          margin: 60px 0;
        }
        .mission, .vision {
          flex: 1;
          background: white;
          padding: 32px;
          border-radius: 32px;
          text-align: center;
          box-shadow: var(--shadow-sm);
          border: 1px solid #eef2ff;
          transition: 0.2s;
        }
        .mission:hover, .vision:hover {
          transform: translateY(-5px);
          box-shadow: var(--shadow-hover);
        }
        .mission i, .vision i {
          font-size: 3rem;
          color: #1e40af;
          margin-bottom: 20px;
        }
        .mission h3, .vision h3 {
          font-size: 1.6rem;
          margin-bottom: 16px;
        }
        .legal-details {
          background: #f8fafc;
          border-radius: 32px;
          padding: 40px;
          margin: 40px 0;
        }
        .legal-details h2 {
          text-align: center;
          margin-bottom: 32px;
        }
        .legal-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
          gap: 30px;
        }
        .legal-item {
          text-align: center;
        }
        .legal-item i {
          font-size: 2rem;
          color: #1e40af;
          margin-bottom: 12px;
        }
        .legal-item h4 {
          font-size: 1.1rem;
          margin-bottom: 8px;
        }
        .legal-item p {
          color: #475569;
        }
        .stats-section {
          margin: 60px 0 40px;
          text-align: center;
        }
        .stats-section h2 {
          margin-bottom: 40px;
        }
        .stats-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
          gap: 30px;
        }
        .stat-block {
          background: white;
          padding: 28px 16px;
          border-radius: 32px;
          box-shadow: var(--shadow-sm);
          border: 1px solid #eef2ff;
        }
        .stat-block h3 {
          font-size: 2.2rem;
          font-weight: 800;
          color: #1e40af;
          margin-bottom: 8px;
        }
        .stat-block p {
          color: #475569;
          font-weight: 500;
        }
        @media (max-width: 720px) {
          .page-hero h1 { font-size: 2rem; }
          .about-text-box h2 { font-size: 1.6rem; }
          .stat-block h3 { font-size: 1.8rem; }
        }
      `}</style>
    </>
  );
};

export default AboutUs;
